var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopups(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 15L6.66667 17.5V15H5C4.33696 15 3.70107 14.7366 3.23223 14.2678C2.76339 13.7989 2.5 13.163 2.5 12.5V5.83334C2.5 5.17029 2.76339 4.53441 3.23223 4.06557C3.70107 3.59673 4.33696 3.33334 5 3.33334H15C15.663 3.33334 16.2989 3.59673 16.7678 4.06557C17.2366 4.53441 17.5 5.17029 17.5 5.83334V9.58334M18.3333 18.3333C18.3333 17.8913 18.1577 17.4674 17.8452 17.1548C17.5326 16.8423 17.1087 16.6667 16.6667 16.6667H15C14.558 16.6667 14.134 16.8423 13.8215 17.1548C13.5089 17.4674 13.3333 17.8913 13.3333 18.3333M14.1667 14.1667C14.1667 14.6087 14.3423 15.0326 14.6548 15.3452C14.9674 15.6577 15.3913 15.8333 15.8333 15.8333C16.2754 15.8333 16.6993 15.6577 17.0118 15.3452C17.3244 15.0326 17.5 14.6087 17.5 14.1667C17.5 13.7246 17.3244 13.3007 17.0118 12.9882C16.6993 12.6756 16.2754 12.5 15.8333 12.5C15.3913 12.5 14.9674 12.6756 14.6548 12.9882C14.3423 13.3007 14.1667 13.7246 14.1667 14.1667Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopups);
export default __webpack_public_path__ + "static/media/popups.fb9e43899921949e0e6a8aa741bc74d0.svg";
export { ForwardRef as ReactComponent };